/**
 * @description: 根据多币种价格列表获取当前币种的价格信息
 * @param {*} priceList(Array)
 * @param {*} currencyName(String) 必传
 * @return {*} Object
 */
const genPrice = function (priceList, currencyName = 'USD') {
  try {
    const price = priceList?.find((item) => item.currency === currencyName);
    if (price) {
      if (price.sell_price && price.price != price.sell_price) {
        price.discount = true;
      }
      return price;
    }
  } catch (error) {
    console.log(error, priceList);
  }
  return { price: '', sell_price: '' };
};
// 计算夹片条目的价格
// Ps: currencyName 必传
export function getItemPriceInfo(item, currencyName = 'USD') {
  const priceInfo = {
    price: '',
    sell_price: '',
  };
  try {
    if (item?.valuationItem) {
      priceInfo.price = Number(item.valuationItem.product_original_price_total).toFixed(2);
      priceInfo.sell_price = (
        Number(item.valuationItem.discount_birthday) +
        Number(item.valuationItem.product_payable) +
        Number(item.valuationItem.product_rule_discounts_price) +
        Number(item.valuationItem.product_point_discounts_price) +
        Number(item.valuationItem.product_code_discounts_price)
      ).toFixed(2);
    } else if (item?.price_info) {
      priceInfo.price = (Number(genPrice(item.price_info, currencyName).price) * item.qty).toFixed(
        2,
      );
      priceInfo.sell_price = (
        Number(genPrice(item.price_info, currencyName).sell_price) * item.qty
      ).toFixed(2);
    }
  } catch (error) {
    console.error(error);
  }
  return priceInfo;
}

// 把夹片的cart_id合并到外层
export function getCartIds(list) {
  const cart_ids = [];
  list?.forEach((item) => {
    cart_ids.push(item.cart_id);
    // 兼容夹片
    if (item.clips?.length) {
      item.clips.forEach((clip) => {
        cart_ids.push(clip.cart_id);
      });
    }
  });
  return cart_ids;
}

// 把接口返回的夹片价格整合到购物车列表的夹片项里
export function setClipValuation(clips, cartPriceList) {
  if (clips?.length) {
    clips.forEach((clip) => {
      const valuationItem = cartPriceList.find((cartPrice) => clip.cart_id === cartPrice.id);
      if (valuationItem) {
        clip.valuationItem = valuationItem;
      }
    });
  }
}

// 从clips获取总价
// Ps: currencyName 必传
export function totalClipPriceInfo(clips, currencyName = 'USD') {
  const totalPrice = {
    price: '',
    sell_price: '',
  };
  try {
    clips?.forEach((item) => {
      const priceInfo = getItemPriceInfo(item, currencyName);
      totalPrice.price = Number(totalPrice.price) + Number(priceInfo.price);
      totalPrice.sell_price = Number(totalPrice.sell_price) + Number(priceInfo.sell_price);
    });
    totalPrice.price = Number(totalPrice.price).toFixed(2);
    totalPrice.sell_price = Number(totalPrice.sell_price).toFixed(2);
  } catch (error) {
    console.error(error);
  }
  return totalPrice;
}
